// apps/web/src/features/agent/artifacts/TableArtifactCard.tsx (#1877)
//
// Renders a `table` artifact via the shared DataTable. Columns map 1:1 to
// `Column<Record<string, string | number>>` (so each `key` resolves to a
// plain string row field), rows pass through verbatim, and the row key is
// the index (model rows carry no id).
//
// INVARIANT (XSS): cell values and column labels are model-supplied and
// render only as JSX text nodes — DataTable renders `row[key]` as a text
// child. No HTML conversion anywhere. See ./ArtifactRenderer.tsx.
import type { Artifact } from '@magimp/shared';
import { DataTable, type Column } from '../../../ui/index.js';

type TableArtifact = Extract<Artifact, { kind: 'table' }>;
type TableRow = Record<string, string | number>;

export function TableArtifactCard({ artifact }: { artifact: TableArtifact }) {
  const columns: Column<TableRow>[] = artifact.columns.map((c) => ({
    key: c.key,
    label: c.label,
    ...(c.align !== undefined ? { align: c.align } : {}),
  }));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--s-2)' }}>
      <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--fg-1)' }}>{artifact.title}</span>
      <DataTable columns={columns} rows={artifact.rows} getRowKey={(_row, i) => i} />
    </div>
  );
}
